
import { RouterProvider } from 'react-router-dom';
import { router } from './mainRouter';
import { useNotification } from './hooks/useNotification';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';
import { cn } from './utils/cn';

/**
 * Single Toast Notification component.
 */
const Toast = ({ id, message, type }: { id: string, message: string, type: string }) => {
  const { removeNotification } = useNotification();

  const icons = {
    success: <CheckCircle className="text-emerald-500" size={18} />,
    error: <AlertCircle className="text-error" size={18} />,
    warning: <AlertTriangle className="text-amber-500" size={18} />,
    info: <Info className="text-navy" size={18} />,
  };

  return (
    <div className={cn(
      "flex items-center gap-3 p-4 bg-white shadow-ambient rounded-2xl border border-outline-variant/10 min-w-[300px] animate-slide-in-right",
    )}>
      <div className="shrink-0">
        {icons[type as keyof typeof icons]}
      </div>
      <p className="text-xs font-bold text-navy flex-1">{message}</p>
      <button
        onClick={() => removeNotification(id)}
        className="text-secondary/40 hover:text-navy transition-colors shrink-0"
      >
        <X size={16} />
      </button>
    </div>
  );
};

const App = () => {
  const { notifications } = useNotification();

  return (
    <>
      <RouterProvider router={router} />

      {/* Toast Portal */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 pointer-events-none">
        {notifications.map((n) => (
          <div key={n.id} className="pointer-events-auto">
            <Toast {...n} />
          </div>
        ))}
      </div>
    </>
  );
};

export default App;
